import { Suspense } from "react";
import BonusXLoading from "../../../legacy/components/BonusXLoading";

export function withSuspense(element: JSX.Element) {
  return <Suspense fallback={<BonusXLoading />}>{element}</Suspense>;
}
